// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { QuestionState_abstract } from './../abstract/SagaBase/QuestionState_abstract';
export class QuestionState extends QuestionState_abstract {}
